module.exports = __webpack_public_path__ + "static/media/logo-precidia-rentals-white.10ef7e68.png";